 <div  class="modal-container popup-general modal-lg percent_25 row" >

    <div class="modal-container-header col-12">
        <span> {{ 'gestion_vehiculos.popup.busquedaConcesionario' | translate}}</span>
        <span class="k-icon k-i-close cursor color_red" (click)="closeVendors()"></span>
    </div>

     <div class="modal-container-section col-12">

                <form class="botones_abecedario"
                    [formGroup]="formGeneric" >
                        <div class="row color_grisTitular">
                            <div class="col-12">
                                <label class="ml-2">
                                {{ 'labels.seguros' | translate }}:</label>

                                <input type="text"
                                placeholder="Buscar..."
                                formControlName="searchInput"
                                class="form-control float-right inline anchurax40 mr-2"  >
                                <span class="input-group-addon">
                                <i class="k-icon k-i-search" (click)="search()"></i>
                                </span>
                        </div>
                    </div>
                </form>

        <div class="row">
            <div class="col-12 " >
            <dms-generic-table
                [pageNumber]= "pageNumber"
                [skip] = "skip"
                [pageSize]= "pageSize"
                [sort]='sort'
                [dataTable]='dataTable'
                [isLoading]='isLoadingVendor'
                (selectAccount)="getRow($event)"
                (pChange)="pageChange($event)" >
            </dms-generic-table>



            </div>
        </div>

    </div>

</div>
